import React from "react"
import { graphql } from "gatsby"
import pk from "../images/pk.png"
import HeaderMenu from "../components/header_menu"
import { withPrefix } from "gatsby"
import { Helmet } from "react-helmet"


export default class BlogPost extends React.Component{
	
  render() {
  const { post, recentPosts} = this.props.data
  const { frontmatter, html } = post

  const style1 = {position: "relative"};
  const style2 = {backgroundPosition: "center", backgroundRepeat: "no-repeat", backgroundSize: "cover"};
  const style3 = {display: "table-cell", width: "70%", verticalAlign: "bottom"};
  const style4 = {marginTop: "50px"};
  const style5 = {textAlign: "center", display: "table-cell", verticalAlign: "bottom", paddingRight: "5px"};
  const style6 = {color: "white", fontFamily: "futura-pt, sans-serif", textShadow: "0 5px 5px rgba(0,0,0,1)"};
  const style7 = {color: "white", textShadow: "0 5px 5px rgba(0,0,0,1)"};
  const style8 = {backgroundColor: "white"};
  const style9 = {fontSize: "larger", textAlign: "center", fontWeight: "bold", paddingBottom: "10px"};
  const style10 = {marginTop: "20px"};
  const style11 = {textAlign: "right", fontWeight: "bold"};
  const style12 = {marginTop: "10px"};
  const style13 = {fontSize: "16px"};
  const trackingCode = `<script>
							(function(w,d,t,u,n,a,m){w['MauticTrackingObject']=n;
							w[n]=w[n]||function(){(w[n].q=w[n].q||[]).push(arguments)},a=d.createElement(t),
							m=d.getElementsByTagName(t)[0];a.async=1;a.src=u;m.parentNode.insertBefore(a,m)
							})(window,document,'script',mauticSrc+'/mtc.js','mt')
							if(document.getElementById('video') != null){
								let videoURLParams = 'rel=0&controls=1&autoplay=0&cc_load_policy=1&modestbranding=1';
								loadVideo(videoURLParams, 'articleContent');
								window.onresize = function(){
									resizeVideo('articleContent');
								};
							}
						</script>`

  return (
  
 <>  

<Helmet>
      {frontmatter.title && (<title>{frontmatter.title}</title>)}
      {frontmatter.description && (<meta name="description" content={frontmatter.description} />)}
      {frontmatter.ogUrl && (<meta property="og:url" content={frontmatter.ogUrl} />)}
      {frontmatter.ogTitle && (<meta property="og:title" content={frontmatter.ogTitle} />)}
      {frontmatter.ogDescription && (<meta property="og:description" content={frontmatter.ogDescription} />)}
	  {frontmatter.ogImage && (<meta property="og:image" content={withPrefix(frontmatter.ogImage.childImageSharp.gatsbyImageData.images.fallback.src)} />)}
</Helmet> 
 
<div id="page-wrapper" style={style1}>
    <div id="content" className="bgclr0">
        
        <HeaderMenu> </HeaderMenu>
  
        <div className="header-container" role="banner">
            <header className="wrapper clearfix bgclr8">
                <div style={style2} className="banner">
                    <div style={style3}>
                        <img src={pk} className="pk" style={style4} />
                    </div>
                    <div style={style5}>
                        <h1 className="title" style={style6}>YOUR HOME SOLD GUARANTEED!*</h1>
                        <div className="contact" style={style7}>
                            <h3>Praveen Kumar</h3>
                            <h3><i className="fa fa-phone"></i> (925) 452-7483</h3>
                            <h3><i className="fa fa-envelope"></i> praveen@weberealty.com</h3>
                        </div>
                    </div>
                </div>
            </header>
        </div>
        
        <div className="main-container" style={style10}>
            <div className="main wrapper clearfix bgclr6">
              
                <article className="bgclr8" role="article">
                    <div id="articleContent" className="articlecnt">
                      <div className="blog-post-container">
                        <div style={style11} className="blog-post-header">
                            <span>{frontmatter.date} {frontmatter.author}</span>
                        </div>
                        <div style={style12} className="blog-post-content" dangerouslySetInnerHTML={{ __html: html }}/>
                      </div>
                    </div>
                </article>

                <aside style={style8} className="bgclr3" id="aside">
                    <div style={style9}>Recent Posts</div>
                    <ul>
                        {recentPosts.edges.map(({ node }) => {
                            let path = withPrefix(node.frontmatter.path);
                            return (
                            <li><a style={style13} href={path}>{node.frontmatter.description}</a></li>
                            )
                        })}
                    </ul>
                </aside>

            </div>
        </div>  
    </div>

    <div className="footer-container">
        <footer className="wrapper">
            <div id="contactinfo"><div id="disclosure"><center>Information courtesy of Praveen Kumar 01928307 @ WebERealty<br/> 12935 Alcosta Blvd. #3681, San Ramon ,California, 94583<br/> praveen@weberealty.com</center></div></div>
        </footer>
    </div>  

</div>
	<div dangerouslySetInnerHTML={{ __html: trackingCode }} />
	</>
  )
}

}
export const pageQuery = graphql`
  query pageQuery($path: String!) {
    post: markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        date(formatString: "MMMM YYYY")
		author
        path
        title
        description
		ogUrl
		ogTitle
		ogDescription
		ogImage{
			childImageSharp {
				gatsbyImageData(layout: FIXED, height: 300, width: 300)
			}
		}
      }
    }
    recentPosts: allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      limit: 20
    ) {
      edges {
        node {
          frontmatter {
            description
            path
          }
        }
      }
    }
  }
`
